import React, { useState } from 'react'
import glamorous from 'glamorous'

import HandleDetailsDialog from './handle-details-dialog'

// content
import getContent from 'pp-react-l10n'
const l10n = getContent('pages/seller/details')

const LinkButton = glamorous.button('vx_btn-link', {
  fontFamily: 'PayPalSansBig-Regular, "Helvetica Neue", Arial, sans-serif',
  fontSize: '0.875rem',
  '@media(max-width: 414px)': {
    textAlign: 'left',
  },
})

const HandleMoreInfoLink = () => {
  const [showDialog, setShowDialog] = useState(false)

  return (
    <>
      <LinkButton
        type="button"
        onClick={() => {
          setShowDialog(!showDialog)
        }}
      >
        {l10n('main.learnMore')}
      </LinkButton>
      <HandleDetailsDialog
        showDialog={showDialog}
        onClose={() => {
          setShowDialog(!showDialog)
        }}
      />
    </>
  )
}

export default HandleMoreInfoLink
